import styled from 'styled-components';
import { Row } from '@simplywallst/ui-core';

export const SkeletonRow = styled(Row)`
  &:not(:first-child) {
    border-top: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  }
  padding-top: 10px;
  padding-left: ${({ theme }) => theme.x1spacePx}px;
  padding-right: ${({ theme }) => theme.x2spacePx}px;
  padding-bottom: 4px;
  > div {
    cursor: auto;
    &:hover {
      background: transparent;
    }
    > span {
      margin-bottom: 6px;
    }
  }
`;
